import { APP_VERSION } from './version';

// Configuration environments
const ENVIRONMENTS = {
  DEVELOPMENT: {
    API_URL: `https://${window.location.hostname}:5000/api`,
    STATIC_URL: `https://${window.location.hostname}:5000`,
    IMAGES_URL: `https://${window.location.hostname}`,
  },
  PRODUCTION: {
    API_URL: `https://${window.location.hostname}/api`,
    STATIC_URL: `https://${window.location.hostname}`,
    IMAGES_URL: `https://${window.location.hostname}`,
  },
  DOCKER: {
    API_URL: `/api`,  // Use relative URL to avoid CORS issues
    STATIC_URL: `https://${window.location.hostname}`,
    IMAGES_URL: `https://${window.location.hostname}`,
  },
};

// Allow explicit API URL override via env var (for local dev against prod backend)
const API_URL_OVERRIDE = import.meta.env.VITE_API_URL as string | undefined;

// Determine current environment
const getEnvironment = () => {
  // Check if running in Docker environment
  if (window.location.hostname !== 'localhost' && window.location.port === '') {
    return 'DOCKER';
  }
  
  // Check if running in development mode
  if (window.location.port === '5173' || window.location.port === '5174') {
    return 'DEVELOPMENT';
  }
  
  // Default to production
  return 'PRODUCTION';
};

const CURRENT_ENV = getEnvironment();
const config = API_URL_OVERRIDE
  ? { ...ENVIRONMENTS[CURRENT_ENV], API_URL: API_URL_OVERRIDE }
  : ENVIRONMENTS[CURRENT_ENV];

// Log configuration for debugging
console.log(`🔧 Fashion App ${APP_VERSION.version} running in ${CURRENT_ENV} mode`);
console.log(`🔧 API URL: ${config.API_URL}`);
console.log(`🔧 Static URL: ${config.STATIC_URL}`);
console.log(`🔧 Images URL: ${config.IMAGES_URL}`);

export default {
  ...config,
  VERSION: APP_VERSION.version,
  BUILD_DATE: APP_VERSION.buildDate,
  ENV: CURRENT_ENV,
};